module.exports = __webpack_public_path__ + "img/ltksalealert-4x.0d1ef21.jpg";